module.exports = __webpack_public_path__ + "assets/img/welcome.85a8cd9a.png";